import { Box, styled } from '@mui/material';

export const StyledRuleEditorButtonsBox = styled(Box)`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
`;
